export default "__VITE_ASSET__CPfOAVAJ__"